import { atom } from "jotai";
import type { IIssuerObject } from "lib/algolia/types/assets";

export interface ISelectedTickerSymbol {
  issuer: IIssuerObject;
  tickerSymbol: string;
}

export const SELECTED_TICKER_SYMBOLS_ATOM = atom<ISelectedTickerSymbol[]>([]);
